import { render, staticRenderFns } from "./ed-paper-type-item.vue?vue&type=template&id=2892dbd7&scoped=true&"
import script from "./ed-paper-type-item.ts?vue&type=script&lang=ts&"
export * from "./ed-paper-type-item.ts?vue&type=script&lang=ts&"
import style0 from "./ed-paper-type-item.scss?vue&type=style&index=0&id=2892dbd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892dbd7",
  null
  
)

export default component.exports